const BASE_URL = 'https://image.tmdb.org/t/p/w150_and_h225_bestv2';

export default function tmdbPosterUrl (path) {
  return `${BASE_URL}${path}`;
}
